import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import shadows from 'theme/atoms/shadows';
import breakpoints from 'theme/atoms/breakpoints';
import * as Text from 'theme/components/Text.style';
import * as Buttons from 'theme/components/Buttons.style';

export const Container = styled('div')`
  background-color: ${colours.shade[0]};
  border: 1px solid ${colours.neutral[300]};
  border-radius: 16px;
  bottom: 16px;
  box-shadow: ${shadows.L};
  display: flex;
  gap: 12px;
  left: 16px;
  padding: 16px;
  position: fixed;
  right: 16px;
  /* Above the app chrome, below MUI dialogs so a modal still covers it. */
  z-index: 1200;

  @media (min-width: ${breakpoints.tabletMin}) {
    margin: 0 auto;
    max-width: 420px;
  }
`;

export const AppIcon = styled('img')`
  border-radius: 10px;
  flex-shrink: 0;
  height: 40px;
  width: 40px;
`;

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Title = styled(Text.P2Semibold)`
  margin: 0;
`;

export const Instructions = styled(Text.P3)`
  color: ${colours.neutral[600]};
  margin: 0;

  /* The share glyph sits inline in the sentence, so it rides the text. */
  svg {
    vertical-align: text-bottom;
  }
`;

export const DismissButton = styled(Buttons.GhostIcon)`
  align-self: flex-start;
  flex-shrink: 0;
  margin-left: auto;
`;
